(function () {
    'use strict';

    angular.module("imApp").factory("discGrpProdsService", [function () {
        let service = {};

        return service;
    }]);
})();
